import { DATA_PRODUCER_WORKSHEET_NAME } from "../../../../../service/globalValues";
import {
  DATA_PRODUCER_TABLE_NAME,
  DEFAULT_BUTTON_TO_UPDATE_TEXT,
  UPDATE_BUTTON_IDX,
} from "../../../../../service/producerServices/constants";
import { protectDataProducerSheet } from "../../../../../service/producerServices/lockEditModeInSomeColumns";

export const resetDataProducerButtonsText = async () => {
  try {
    await Excel.run(async (context) => {
      const worksheet = context.workbook.worksheets.getItemOrNullObject(DATA_PRODUCER_WORKSHEET_NAME);
      const table = worksheet.tables.getItemOrNullObject(DATA_PRODUCER_TABLE_NAME);

      table.load(["columns", "isNullObject"]);
      worksheet.load("isNullObject");
      await context.sync();

      if (worksheet.isNullObject || table.isNullObject) return;

      worksheet.protection.unprotect();

      const buttonsRange = table.columns.getItem(UPDATE_BUTTON_IDX + 1).getDataBodyRange();

      buttonsRange.load("values");
      await context.sync();

      buttonsRange.values = buttonsRange.values.map(() => [DEFAULT_BUTTON_TO_UPDATE_TEXT]);

      await protectDataProducerSheet({ worksheet });

      await context.sync();
    });
  } catch (error) {
    console.error("Error while resetting data producer buttons text", error);
  }
};
